module.exports = __webpack_public_path__ + "static/choose-pass-bab2cc11d65490adffda4c58f27e2b29.png";